import { AfterViewInit, Component, ElementRef, Inject, PLATFORM_ID, Renderer2, ViewChild } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import * as AOS from 'aos';
import { Constants } from '../../common/constants';
import { MiteventsService } from '../../mitevents.service';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';

export interface testimonial{
  id:number;
  name:string;

  companyName:string;
  designation:string;
  imageUrl:string;
  comment:string;
}
@Component({
  selector: 'app-recognition',
  templateUrl: './recognition.component.html',
  styleUrls: ['./recognition.component.css']
})



export class RecognitionComponent implements AfterViewInit {

  breakpoints = {
    320: {slidesPerView: 1},
    640: {slidesPerView: 1},
    768: {slidesPerView: 2},
    1024: {slidesPerView: 2},
  };

  @ViewChild('swiperContainer', { static: false }) swiperContainer!: ElementRef;
  @ViewChild('empSwiperContainer', { static: false }) empSwiperContainer!: ElementRef;
  testimonials: testimonial[] = [];
  testimonialChunks: testimonial[][] = [];
  isBrowser:boolean=false;
  

 
  constructor(private renderer: Renderer2, private titleService: Title, 
     private seoService:SeoService,   @Inject(PLATFORM_ID) private platformId: any,
     private _renderer2: Renderer2,
     @Inject(DOCUMENT) private _document: Document,
    private metaService: Meta, private eventService: MiteventsService) {
      this.isBrowser=isPlatformBrowser(this.platformId);    }
baseUrl = Constants.baseUrl;

ngOnInit(): void {
  let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
{
  "@context": "https://schema.org",
  "@type": "Article",
  "mainEntityOfPage": {
    "@type": "WcebPage",
    "@id": "https://mitresource.com/recognition/"
  },
  "headline": "Recognition | Awards and Accolades for Maganti IT",
  "description": "Over 24 years experience as a demonstrated leader, and in-depth technology expertise - Sushma strives to sustain a culture of diversity and inclusion.",
  "image": "https://mitresource.com/assets/images/journey/sushma-mam-image.png",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT",
    "url": "https://mitresource.com/"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2024-10-24"
}`;
   
    this._renderer2.appendChild(this._document.head, script);
   this.seoService.createLinkForCanonicalURL();

  this.setTitleAndMetaTags();

  if(this.isBrowser){     
    AOS.init({disable: 'mobile', duration: 2000, delay: 500,});
  }
 
  
  this.loadTestimonials();
}

private setTitleAndMetaTags(): void {
  this.titleService.setTitle('Recognition | Awards and Accolades for Maganti IT');

  this.metaService.addTags([
    { name: 'description', content: 'Thank you for the work you did with the rebrand.' },
    { property: 'og:type', content: 'website' },
    { property: 'og:title', content: 'Recognition | Awards and Accolades for Maganti IT' },
    { property: 'og:url', content: 'https://mitresource.com/recognition/' },
    { property: 'og:image', content: 'https://mitresource.com/assets/images/recognition/santos-image.png' },
    { property: 'og:description', content: 'Thank you for the work you did with the rebrand.' },
  ]);
}
ngAfterViewInit() {
if(this.isBrowser){

  const swiperElements=this.empSwiperContainer.nativeElement;
  const shadowRoots=swiperElements.shadowRoot;
 if(shadowRoots){
    const page=shadowRoots.querySelector('.swiper-pagination')
    if(page){
      this.renderer.setStyle(page, 'position', 'unset');  
    }
    else{
    }
   }else{
   
   }// Ensure swiperContainer is available

  }
}

 
happyCustomerSwiperInstallation() {
  // Ensure the right swiper is targeted
  if (this.swiperContainer) {
    setTimeout(() => {
      const swiperElement = this.swiperContainer.nativeElement;
      const shadowRoot = swiperElement.shadowRoot;
    
      if (shadowRoot) {
        const paginationElement = shadowRoot.querySelector('.swiper-pagination');
        if (paginationElement) {
          // Apply styles to the pagination bullets for the customer swiper
          this.renderer.setStyle(paginationElement, 'position', 'unset');          
        } else {
          console.error('Customer pagination element not found in shadow root');
        }
      } else { 
        console.error('Customer shadow root not found');
      }
    }, 2000);
  }
}

 

  loadTestimonials() {
    this.eventService.getTestimonials().subscribe({
      next: (data: testimonial[]) => {
        this.testimonials = data;
        // this.testimonialChunks = this.chunkArray(this.testimonials, 3);
        this.testimonialChunks = this.chunkArray(this.testimonials, 1);
         
        this.happyCustomerSwiperInstallation();
      },
      error: (error) => {
      }
    });
  }
  swiperBreakpoints = {
    320: { slidesPerView: 1 },      
    768: { slidesPerView: 2 },      
    1024: { slidesPerView: 2 }      
  };

  swiperHCBreakpoints={
    320: { slidesPerView: 1 },      
    768: { slidesPerView: 2 },      
    1024: { slidesPerView: 2 } ,   
    1244: { slidesPerView: 3 }      
  };

  chunkArray(arr: any[], chunkSize: number): any[][] {
    let index = 0;
    let arrayLength = arr.length;
    let tempArray = [];
  
    for (index = 0; index < arrayLength; index += chunkSize) {
      let chunk = arr.slice(index, index + chunkSize);
      tempArray.push(chunk);
    }
  
    return tempArray;
  }


  getImageUrl(bannerImage:string){
    if(bannerImage!=null){
    
    return Constants.baseImageUrl + bannerImage;
    }else{
      return '../../../assets/images/InternshipPage/business-conference-banner-template-design-for-webinar-marketing-online-class-program-etc-free-vector.jpg'
    }
      }
  
}
